/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.125.1-v202605212025-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import * as models from './models';

/**
 * The input features of the model
 */
export interface InputFeatureV1 {
    /**
     * Stable identifier for a feature that persists across model versions
     */
    "canonicalId"?: string;
    /**
     * Description of the input feature
     */
    "description"?: string;
    /**
     * Unique identifier of the input feature; omit on create
     */
    "id"?: string;
    /**
     * Name of the input feature
     */
    "name"?: string;
    /**
     * Type of the feature output
     */
    "outputType"?: OutputTypeEnum;
}

export enum OutputTypeEnum {
    TEXT = 'TEXT',
    NUMERIC = 'NUMERIC',
    ITEMID = 'ITEM_ID',
    BOOLEAN = 'BOOLEAN'
}
